import { useEffect, useState } from 'react';
import { BUILD_VERSION } from '../buildInfo';

const POLL_INTERVAL_MS = 2 * 60 * 1000;

export default function useVersionCheck() {
  const [hasNewVersion, setHasNewVersion] = useState(false);

  useEffect(() => {
    if (process.env.NODE_ENV !== 'production') return undefined;

    let cancelled = false;

    async function check() {
      try {
        const response = await fetch(`/version.json?t=${Date.now()}`, {
          cache: 'no-store',
        });
        if (!response.ok) return;
        const { version } = await response.json();
        if (!cancelled && version && version !== BUILD_VERSION) {
          setHasNewVersion(true);
        }
      } catch (e) {
        // network blip — try again next interval
      }
    }

    check();
    const intervalId = setInterval(check, POLL_INTERVAL_MS);
    const onFocus = () => check();
    window.addEventListener('focus', onFocus);

    return () => {
      cancelled = true;
      clearInterval(intervalId);
      window.removeEventListener('focus', onFocus);
    };
  }, []);

  return hasNewVersion;
}
